import { useNavigate } from "react-router";
import "./BackBtn.css";

function BackBtn(props: any) {
  const navigate = useNavigate();

  return (
    <button
      className={`button circle d-flex justify-content-center align-items-center ${props.backTo === "quality-control" || props.backTo === "client-ready" ? "back-btn-reduce" : ""}`}
      onClick={() => (props.backTo === "quality-control" ? navigate("/documents?view=quality-control") : navigate(-1))}>
      <span className="material-symbols-outlined">arrow_back</span>
    </button>
  );
}

export default BackBtn;
